import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanelContent,{attrs:{"expand-icon":_vm.iconClass},model:{value:(_vm.isCollapsed),callback:function ($$v) {_vm.isCollapsed=$$v},expression:"isCollapsed"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.question))]),_c('div',{staticClass:"answer",domProps:{"innerHTML":_vm._s(_vm.answer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }